module.exports = __webpack_public_path__ + "img/guide.e6a2d3db.png";